import hasVip from './hasVip'

const install = function (Vue) {
  Vue.directive('hasVip', hasVip)
}

if (window.Vue) {
  Vue.use(install) // eslint-disable-line
}

export default install
